import GeolocationHandler                         from '../GeolocationHandler'
import { http }                                   from '@/http'
import { SchedulerResourceValueObject }           from '../value-objects/scheduler-resource.value-object'
import { SchedulerResourceValueObjectCollection } from '../collection/scheduler-resource.value-object.collection'
import { SchedulerEventValueObjectCollection }    from '../collection/scheduler-event.value-object.collection'
import { SchedulerEventValueObject }              from '../value-objects/scheduler-event.value-object'
import { SchedulerTaskValueObject }               from '../value-objects/scheduler-task.value-object'
import { SchedulerTaskValueObjectCollection }     from '../collection/scheduler-task.value-object.collection'
import { SchedulerConfigValueObject }             from '../value-objects/scheduler-config.value-object'

export default new class SchedulerResource {

  constructor () {
    this.urlGetResources  = 'Scheduler/getResources'
    this.urlGetTasks      = 'Scheduler/getTasks'
    this.urlGetEvents     = 'Scheduler/getEvents'
    this.urlGetParameters = 'Scheduler/getParameters'

    this.urlSuggest = 'Scheduler/Suggest'
    this.urlUpdate  = 'Scheduler/Update'
    this.urlDelete  = 'Scheduler/Delete'

    this.geolocationHandler = GeolocationHandler
  }

  /**
   *
   * @param task {SchedulerTaskValueObject}
   * @returns {*|Q.Promise<any>|AxiosPromise<any>|void}
   */
  suggest (task) {
    if (!task instanceof SchedulerEventValueObject) {
      throw new Error('event is not type SchedulerEventValueObject')
    }

    return http.post(this.urlSuggest, task.toApiObject())
  }

  /**
   *
   * @param data {SchedulerEventValueObject|{}}
   * @returns {*|Q.Promise<any>|AxiosPromise<any>|void}
   */
  update (data) {
    if (data instanceof SchedulerEventValueObject) {
      data = data.toApiObject()
    }

    return http.post(this.urlUpdate, data)
  }

  /**
   *
   * @param event {SchedulerEventValueObject}
   * @returns {*|Q.Promise<any>|AxiosPromise<any>|void}
   */
  delete (event) {
    if (!event instanceof SchedulerEventValueObject) {
      throw new Error('event is not type SchedulerEventValueObject')
    }

    return http.post(this.urlDelete, event.toApiObject())
  }

  /**
   *
   * @returns {Promise<SchedulerResourceValueObjectCollection>}
   */
  async getResources (viewResource, viewActivity, viewUserGroup, searchKeyword) {
    let params = {},
        output = new SchedulerResourceValueObjectCollection()

    let result = await this.geolocationHandler.getPromise().then(() => {
      params = this.geolocationHandler.extendParams(params)

      let url = this.urlGetResources
        + '?ViewResource=' + viewResource
        + '&ViewActivity=' + viewActivity
        + '&ViewUserGroup=' + viewUserGroup

      if (searchKeyword) {
        url += '&ResourceNameFilter=' + searchKeyword
      }

      return http.get(url)
    })

    result.data.forEach((item) => {
      output.push(SchedulerResourceValueObject.fromApiObject(item))
    })

    return output
  }

  /**
   *
   * @returns {Promise<SchedulerTaskValueObjectCollection>}
   */
  async getTasks () {
    let params = {},
        output = new SchedulerTaskValueObjectCollection()

    let result = await this.geolocationHandler.getPromise().then(() => {
      params = this.geolocationHandler.extendParams(params)

      return http.get(this.urlGetTasks)
    })

    result.data.forEach((item) => {
      output.push(SchedulerTaskValueObject.fromApiObject(item))
    })

    return output
  }

  /**
   *
   * @returns {Promise<SchedulerEventValueObjectCollection>}
   */
  async getEvents (dateFrom, dateTo, resources, viewEndedTask, viewEndedActivity) {
    let params = {},
        output = new SchedulerEventValueObjectCollection()

    let result = await this.geolocationHandler.getPromise().then(() => {
      params = this.geolocationHandler.extendParams(params)

      return http.get(
        this.urlGetEvents
          + '?DateFrom=' + dateFrom
          + '&DateTo=' + dateTo
          + '&Resources=' + JSON.stringify(resources)
          + '&ViewEndedTask=' + viewEndedTask
          + '&ViewEndedActivity=' + viewEndedActivity
      )
    })

    result.data.forEach((item) => {
      output.push(SchedulerEventValueObject.fromApiObject(item))
    })

    return output
  }

  /**
   *
   * @returns {Promise<SchedulerConfigValueObject>}
   */
  async getConfig () {
    let params = {}

    let result = await this.geolocationHandler.getPromise().then(() => {
      params = this.geolocationHandler.extendParams(params)

      return http.get(this.urlGetParameters)
    })

    return SchedulerConfigValueObject.fromApiObject(result.data[0])
  }
}()
